<script setup lang="ts">
import { ref, onMounted, onUnmounted, toRefs } from "vue";
import NotifyContainer from "@/stories/displays/NotifyContainer/NotifyContainer.vue";

interface Props {
  backdropType?: string;
}

const props = withDefaults(defineProps<Props>(), {
  backdropType: "gray",
});

const dialogRef = ref();

const { backdropType } = toRefs(props);

const emit = defineEmits(["onOpen", "onClose"]);

const handleCancelEvent = (event: Event) => {
  emit("onClose");

  event.stopPropagation();
};

onMounted(async () => {
  if (!dialogRef.value) {
    return;
  }

  dialogRef.value.addEventListener("cancel", handleCancelEvent);

  if (dialogRef.value.showModal) {
    dialogRef.value.showModal();
  }
});

onUnmounted(() => {
  dialogRef?.value?.close();
  dialogRef?.value?.removeEventListener("cancel", handleCancelEvent);
});
</script>

<template>
  <dialog
    ref="dialogRef"
    :class="[
      'bg-neutral0 rounded-2xl animate-in fade-in duration-500 focus-visible-base',
      `backdrop-${backdropType}`,
      backdropType === 'gray'
        ? 'backdrop:bg-neutral1000 backdrop:opacity-40'
        : '',
    ]"
  >
    <slot></slot>
    <NotifyContainer />
  </dialog>
</template>
